import type { ScreenKey } from '@/routes/screens';

/** Full previews require explicit local MSW development or the isolated unit-test mode. */
export function firstMvpScope(env: {
  DEV: boolean;
  MODE?: string;
  VITE_ENABLE_MSW?: string;
  VITE_PRODUCT_SCOPE?: string;
}) {
  return !(
    env.DEV &&
    (env.VITE_ENABLE_MSW === 'true' || env.MODE === 'test') &&
    env.VITE_PRODUCT_SCOPE === 'full'
  );
}

export const firstMvp = firstMvpScope(import.meta.env);

export const MVP_SCREENS = [
  'welcome',
  'home',
  'search',
  'questions',
  'questionDetail',
  'journeys',
  'journeyDetail',
  'trends',
  'trendDetail',
  'explore',
  'exploreMap',
  'experienceDetail',
  'treatmentDetail',
  'clinicDetail',
  'auth',
  'diagnosis',
  'diagnosisResult',
  'chat',
  'chatRoom',
  'plans',
  'planner',
  'plannerInbox',
  'plannerConversation',
  'checkout',
  'checkoutComplete',
  'trip',
  'itinerary',
  'travelInfo',
  'bookings',
  'bookingDetail',
  'my',
  'membership',
  'products',
  'productDetail',
  'points',
  'vouchers',
  'voucherDetail',
  'voucherOrder',
  'coupons',
  'settings',
  'notifications',
  'payments',
  'commerceRefund',
  'saved',
  'recent',
  'reviews',
  'bookingReview',
  'aftercareList',
  'aftercare',
  'help',
  'legal',
  'notFound',
] as const satisfies readonly ScreenKey[];

export function availableScreen(key: string, mvp = firstMvp) {
  return !mvp || MVP_SCREENS.some((screen) => screen === key);
}
